import i18n from 'i18next';
import en from './translations/en.json';
import fr from './translations/fr.json';
import enValues from './translations/en.values.json';
import frValues from './translations/fr.values.json';
import { initReactI18next } from 'react-i18next';
import StorageService, {SupportedLanguagesType} from '../services/storage.service';
import { setLanguageHeader } from '../common/http';

export const supportedLanguages = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'fr',
    label: 'Français',
  },
];


export let lang = StorageService.getLanguage();
// set language at first app opening
if (!lang) {
  const browserLanguage = navigator.language.slice(0, 2) as SupportedLanguagesType;
  const isBrowserLanguageSupported = supportedLanguages.filter(it => it.value === browserLanguage).length > 0;
  lang = isBrowserLanguageSupported ? browserLanguage : 'en' as SupportedLanguagesType;
  StorageService.updateLanguage(lang);
}
setLanguageHeader(lang);

export const resources = {
  en: {
    translation: en,
    values: enValues,
  },
  fr: {
    translation: fr,
    values: frValues,
  },
} as const;

i18n.use(initReactI18next).init({
  lng: lang,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});
